<template>
  <div v-if="traits.length > 0" class="trait-container">
    <v-divider class="my-2"></v-divider>
    <div class="trait-wrapper">
      <v-chip
        v-for="trait in traits"
        :key="trait.id"
        size="small"
        class="trait-chip me-1 mb-1"
        variant="tonal"
        label
      >
        <template #prepend>
          <v-icon
            :color="traitsStore.getTraitColor(trait.id)"
            size="small"
            class="trait-icon"
          >
            {{ traitsStore.getTraitIcon(trait.id) }}
          </v-icon>
        </template>
        {{ trait.name }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted } from "vue";
import { useSelectedTraitsStoreRefactor } from "@/stores/selectedTraitsStoreRefactor";
import { useTraitsStoreRefactor } from "@/stores/traitsStoreRefactor";

export default defineComponent({
  name: "ReportTraitGroup",
  props: {
    report_id: {
      type: Number,
      required: true,
    },
    preloadedTraits: {
      type: Array,
      default: () => [],
    },
    shouldFetch: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const selectedTraitsStore = useSelectedTraitsStoreRefactor();
    const traitsStore = useTraitsStoreRefactor();

    const traits = computed(() => {
      if (props.preloadedTraits && props.preloadedTraits.length > 0) {
        return props.preloadedTraits;
      }
      return selectedTraitsStore.getTraitsByReport(props.report_id);
    });

    // No status-based styling needed anymore

    const fetchTraits = async () => {
      if (
        props.shouldFetch &&
        (!props.preloadedTraits || props.preloadedTraits.length === 0)
      ) {
        console.warn(
          "ReportTraitGroup: fetchTraits is deprecated. Please preload traits or ensure account data is fetched.",
        );
      }

      // Ensure traits store is loaded for icon/color data
      await traitsStore.fetchAll();
    };

    onMounted(fetchTraits);

    return {
      traits,
      traitsStore,
    };
  },
});
</script>

<style>
.trait-container {
  width: 100%;
  overflow: hidden;
}

.trait-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
}

.trait-chip {
  max-width: calc(100% - 8px);
  overflow: hidden;
  text-overflow: ellipsis;
}

.trait-icon {
  margin-right: 4px !important;
}

.strikethrough {
  text-decoration: line-through;
  opacity: 0.8;
}
</style>
